import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityNaturalezaJuridicaState,
  entityNaturalezaJuridicaAdapter
} from './entity-naturalezas-juridica.state';
import {
  entityNaturalezaJuridicaAddFailure,
  entityNaturalezaJuridicaAddRequest,
  entityNaturalezaJuridicaAddSuccess,
  entityNaturalezaJuridicaChangeFailure,
  entityNaturalezaJuridicaChangeRequest,
  entityNaturalezaJuridicaChangeSuccess,
  entityNaturalezaJuridicaDeleteFailure,
  entityNaturalezaJuridicaDeleteRequest,
  entityNaturalezaJuridicaDeleteSuccess,
  entityNaturalezaJuridicaLoadFailure,
  entityNaturalezaJuridicaLoadRequest,
  entityNaturalezaJuridicaLoadSuccess
} from './entity-naturalezas-juridica.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityNaturalezaJuridicaLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityNaturalezaJuridicaLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityNaturalezaJuridicaLoadSuccess, (state, { items }) =>
    entityNaturalezaJuridicaAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  //add
  on(entityNaturalezaJuridicaAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityNaturalezaJuridicaAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityNaturalezaJuridicaAddSuccess, (state, { item }) =>
    entityNaturalezaJuridicaAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityNaturalezaJuridicaChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityNaturalezaJuridicaChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityNaturalezaJuridicaChangeSuccess, (state, { item }) =>
    entityNaturalezaJuridicaAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityNaturalezaJuridicaDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityNaturalezaJuridicaDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityNaturalezaJuridicaDeleteSuccess, (state, { item }) =>
    entityNaturalezaJuridicaAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function naturalezasJuridicaReducer(
  state: EntityNaturalezaJuridicaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
